import React from 'react';
import { createContext } from 'react';
import { CustomVizDefinition } from 'libs/end-to-end/src/custom-viz-definition';
import { UserAnalysisInformations } from 'libs/end-to-end/src/types/user-analysis/user-analysis-details';
import { CustomVizRequest } from 'libs/end-to-end/src/custom-viz/CustomVizRequest';

export interface UserAnalysisContext {
  sendSignal: (definition: CustomVizDefinition) => void;
  currentUserAnalyses: UserAnalysisInformations | null;
  onDeleteUserAnalysis: (params: { analysisId: string }) => void;
  onRetryUserAnalysis: (customViz: CustomVizRequest) => void;
}

export const UserAnalysisContext = createContext<UserAnalysisContext>({
  sendSignal: () => {},
  currentUserAnalyses: [],
  onDeleteUserAnalysis: () => {},
  onRetryUserAnalysis: () => {},
});
